import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65fa0b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-main" }
const _hoisted_2 = { class: "van-hairline--bottom" }
const _hoisted_3 = { class: "van-hairline--bottom" }
const _hoisted_4 = { class: "nongfu-button-wrap" }

import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, ref, Ref } from 'vue'
import { useCrmAreaInfo } from '@/compositions/common'
import { SelectedAddressInfoStorage } from '@/storage/agricultura-loan'
import { Form, Field, FieldRule, Button, Popup, Cascader, CascaderOption } from 'vant'
import AppHeader from '@/components/Header.vue'
import ItemInfo from '../nameplate-reissue/components/item-info.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'address-select',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const formData = ref({
  area: '',
  detail: '',
})
const formVm = ref()
const areaPopupShow = ref(false)
const showAreaValue = ref('')
const areaInfo: Ref<string[]> = ref([])
const { getAreaCascaderOptions } = useCrmAreaInfo({
  max: 3,
})
const options: Ref<CascaderOption[]> = ref([])

const AreaLabel = '地区'
const detailAddressLabel = '详细地址'

const fomrAreaRules: FieldRule[] = [{ required: true, message: `请选择${AreaLabel}` }]
const formDetailAddressRules: FieldRule[] = [
  { required: true, message: `请输入${detailAddressLabel}` },
]
const headerTitle = computed(() => {
  return ($route.query.title as string) || '地址选择'
})
const canConfirm = computed(() => {
  return formData.value.area && formData.value.detail
})

function selectAreaHandle() {
  areaPopupShow.value = true
}

async function onChange(data: {
  value: string
  tabIndex: number
  selectedOptions: CascaderOption[]
}) {
  const value = data.value
  const index = data.tabIndex
  const current = data.selectedOptions[data.selectedOptions.length - 1]
  console.log('current', current)
  if (!current?.children || index === 2) {
    return
  }
  try {
    const result = await getAreaCascaderOptions({
      p_area_id: Number(value),
    })
    current.children = result.map((item) => ({
      ...item,
    }))
  } catch (error) {
    console.log('error', error)
  }

  // 可以在这里异步加载地址信息
}

function onFinish(data: { selectedOptions: CascaderOption[] }) {
  // 确认
  areaPopupShow.value = false
  showAreaValue.value = data.selectedOptions.map((item) => item.text).join(' ')
  areaInfo.value = data.selectedOptions.map((item) => String(item.value))
}
async function nextHandle() {
  const data = await formVm.value?.submit()
}

function confirmSelectHandle() {
  SelectedAddressInfoStorage.set({
    title: headerTitle.value,
    areaInfo: areaInfo.value,
    showAreaValue: showAreaValue.value,
    detail: formData.value.detail,
  })
  $router.go(-1)
}

async function initAreaInfo() {
  try {
    const data = await getAreaCascaderOptions()
    options.value = data
    // 循环加载已选中数据
    if (areaInfo.value) {
      // let current = options.value
      // for (let i = 0; i < areaInfo.value.length; i++) {
      //   const id = areaInfo.value[i]
      //   const result = await getAreaCascaderOptions({
      //     p_area_id: Number(id),
      //   })
      //   current = current.filter((item) => Number(item.value) === Number(id))
      //   if (current[0]) {
      //     current[0].children = result
      //     current = current[0].children
      //   }
      // }
      formData.value.area = areaInfo.value.slice(-1)[0]
      console.log('ormData.value', formData.value)
    }
  } catch (error) {
    console.log('error', error)
  }
}
onMounted(() => {
  const { areaText = '', areaValue = '', detail } = $route.query
  if (areaText) {
    showAreaValue.value = areaText as string
  }
  if (areaValue) {
    areaInfo.value = (areaValue as string).split(',')
  }
  if (detail) {
    formData.value.detail = detail as string
  }
  initAreaInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: _unref(headerTitle) }, null, 8, ["title"]),
    _createVNode(_unref(Form), {
      class: "main-wrap nongfu-field-placeholder-wrap",
      ref_key: "formVm",
      ref: formVm,
      onSubmit: confirmSelectHandle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "label",
              required: ""
            }, _toDisplayString(AreaLabel)),
            _createVNode(_unref(Field), {
              modelValue: formData.value.area,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.area) = $event)),
              rules: fomrAreaRules,
              class: "field-item"
            }, {
              input: _withCtx(() => [
                _createElementVNode("div", {
                  class: "cell-arrow-right",
                  onClick: selectAreaHandle
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["text", showAreaValue.value ? '' : 'placehoder-color'])
                  }, _toDisplayString(showAreaValue.value || `请选择${AreaLabel}`), 3)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "label",
              required: ""
            }, _toDisplayString(detailAddressLabel)),
            _createVNode(_unref(Field), {
              modelValue: formData.value.detail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.detail) = $event)),
              placeholder: '请输入' + detailAddressLabel,
              rules: formDetailAddressRules,
              class: "field-item"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(Popup), {
      show: areaPopupShow.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((areaPopupShow).value = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Cascader), {
          modelValue: formData.value.area,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.area) = $event)),
          title: "请选择所在地区",
          options: options.value,
          "active-color": "#00C378",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (areaPopupShow.value = false)),
          onChange: onChange,
          onFinish: onFinish
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        class: "next-button xa-vant-button",
        disabled: !_unref(canConfirm),
        round: "",
        onClick: nextHandle
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})